import React from "react"
import PropTypes from "prop-types"

const PATH_NUMBERS = {
  1: "M62.9225 73.4286H94.3838V100H0V73.4286H31.6043L31.8903 33.7143C21.0218 43.2857 10.4394 43.2857 0 43.2857V16.7143C14.7296 16.7143 31.4613 16.7143 31.4613 0H62.9225V73.4286Z",
  2: "M112 30.9859C112 66.0563 52.7557 58.5916 46.1259 73.8028H110.589V100H0V85.0704C0 46.1972 80.9672 52.5352 80.9672 34.3662C80.9672 28.3099 76.7355 26.1972 59.5264 26.1972C42.1763 26.1972 32.8665 27.7465 32.8665 40.1408H1.83375C1.83375 6.90141 24.9673 0 58.1159 0C92.1108 0 112 6.47887 112 30.9859Z",
  3: "M95.7305 50C104.736 54.4444 110 61.25 110 70.9722C110 93.1944 90.466 100 56.3854 100C22.7204 100 0 93.1944 0 61.8056H30.4786C30.4786 73.4722 40.4534 74.1667 57.7708 74.1667C74.1184 74.1667 79.5214 73.4722 79.5214 66.25C79.5214 58.3333 74.1184 57.9167 43.9169 57.9167V42.0833C73.7028 42.0833 79.5214 41.6667 79.5214 33.75C79.5214 26.9444 74.9496 25.8333 57.7708 25.8333C39.2065 25.8333 30.4786 26.9444 30.4786 38.1944H0C0 6.80556 22.7204 0 56.3854 0C90.466 0 110 6.80556 110 29.0278C110 38.75 104.736 45.5555 95.7305 50Z",
  4: "M116 59.5714V86.1429H98.8993V100H67.5479V86.1429H0V59.5714L67.5479 0H98.8993V59.5714H116ZM31.0663 59.5714H67.5479V28.5714L31.0663 59.5714Z",
  5: "M71.3753 33.2394C96.9068 33.2394 112 45.493 112 65.6338C112 90.1408 92.1108 100 58.1159 100C24.6851 100 0 93.5211 0 63.2394H31.0327C31.0327 72.2535 41.1889 73.8028 58.8212 73.8028C75.8892 73.8028 80.9672 69.1549 80.9672 60.8451C80.9672 53.0986 76.8766 48.169 61.5013 48.169C52.0504 48.169 43.1637 50 29.0579 55.6338L4.51385 51.2676L17.2091 0H104.947V24.0845H39.4962L33.8539 41.1268C46.4081 36.0563 55.2947 33.2394 71.3753 33.2394Z",
}

const NumberText = ({ number, description, isLast }) => {
  const path = PATH_NUMBERS[number] || PATH_NUMBERS[1]
  return (
    <div className="flex flex-1 items-center md:items-start md:flex-col md:gap-3 xl:gap-8">
      <div className="text-48 md:text-[36px] xl:text-[100px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.65em"
          height="1em"
          viewBox="0 0 165 100"
          fill="none"
        >
          <path d={path} fill="#151124" />
          {isLast ? (
            <>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M124 100H84V88H124V100Z"
                fill="#52F597"
              />
              <path
                className="hidden md:inline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M153 100H139V88H153V100Z"
                fill="#52F597"
              />
              <path
                className="hidden md:inline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M165 74L165 100L153 100L153 74L165 74Z"
                fill="#52F597"
              />
            </>
          ) : (
            <>
              <path
                className="hidden md:inline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M165 64.125L135.693 96.125L127 88.0013L148.867 64.125L127 40.2487L135.693 32.125L165 64.125Z"
                fill="#52F597"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M119 100H79V88H119V100Z"
                fill="#52F597"
              />
            </>
          )}
        </svg>
      </div>
      <p className="text-bcoral font-inter text-14 xl:text-24 font-normal leading-140% max-w-[234px] md:max-w-none">
        {description}
      </p>
    </div>
  )
}

NumberText.propTypes = {
  number: PropTypes.number,
  description: PropTypes.string,
  isLast: PropTypes.bool,
}

NumberText.defaultProps = {
  number: 1,
  isLast: false,
}

export default NumberText
